import { AxiosError } from 'axios';
import { HcsAPI } from '..';
import { formatAxiosError } from '../api-error-handler';

class FileRepository {
  async get(fileId: string): Promise<Blob> {
    try {
      const { data } = await HcsAPI.get(`files/${fileId}`, {
        responseType: 'blob',
        headers: {
          Accept: 'application/octet-stream',
        },
      });
      return data;
    } catch (error) {
      throw formatAxiosError(error as AxiosError, 'An error has occured while retrieving file.');
    }
  }
}

export default new FileRepository();
